// This is a temporary check used during the duration of the helpful reviews SEO test: https://alltrails.atlassian.net/browse/GROW-11933
const diAdminUserIds = [
  43317014, 49926066, 52694689, 49577949, 23865233, 49083975, 50925835, 75330112, 74740301, 70354462, 29846940, 60846965, 52888402, 74755632,
  17283954, 52428039, 50943794, 39014137, 75830369, 45310132, 16909060, 74755378, 47744136, 51326181, 36035253, 27000987, 74756075, 55263788,
  52267371, 55263669, 28003990, 57954188, 23794899, 74760458, 46738124, 65828995, 29413233, 78496054, 77538798, 22749528, 54567137, 45305460,
  60077273, 60513709, 11445449, 25191269, 33681473, 15702438, 39774519, 38339184, 12830680, 38339184, 12830680, 86767869, 96379198, 96379065, 96379295
];

const isUserDiAdmin = (userId?: number) => !!userId && diAdminUserIds.includes(userId);

export default isUserDiAdmin;
